import React, { ReactNode } from 'react';

import {
  CustomTableCatalogPanel,
  CustomTableContent,
  CustomTableItemsScrollArea,
  CustomTableLayout,
  CustomTableMain,
  CustomTableSelectionPanel,
} from './styles';

type CustomTableBuilderProps = {
  header: ReactNode;
  selection: ReactNode;
  catalog: ReactNode;
  'data-test-id'?: string;
};

export const CustomTableBuilder = ({
  header,
  selection,
  catalog,
  'data-test-id': dataTestId,
}: CustomTableBuilderProps) => (
  <CustomTableLayout data-test-id={dataTestId}>
    <CustomTableMain>
      {header}
      <CustomTableContent>
        <CustomTableSelectionPanel>
          <CustomTableItemsScrollArea>{selection}</CustomTableItemsScrollArea>
        </CustomTableSelectionPanel>
        <CustomTableCatalogPanel>{catalog}</CustomTableCatalogPanel>
      </CustomTableContent>
    </CustomTableMain>
  </CustomTableLayout>
);
